<template lang="pug">
  .page-alarms.row.column
    alarm-list-form(@filterAlarms="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", ref="list")
</template>
<script type="text/babel">

  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import HeaderColumns from "components/structure/ui/HeaderColumns";
  import AlarmListForm from "../../components/structure/ui/filters/AlarmListForm";
  import BaseList from "./BaseList";

  export default {
    name: 'Alarms',
    components: {
      HeaderColumns,
      BaseList,
      AlarmListForm
    },
    data() {
      return {
        component: require('components/backoffice/Alarm'),
        headers: [''],
        search:null,
      }
    },

    methods: {

      setSearch(search) {
        this.search = search
        console.log(this.search)
        // TODO: I down know why the watcher is not picking up the change
         this.$refs.list.debouncedLoader()

      },
      dataLoader(callback, page, resultsPerPage) {

        KeplerBackofficeSdk.alarms.list(page, resultsPerPage).all((data) => {
          callback(data)
        }, () => null, this.search)
      },
    },
  }


</script>
<style lang="sass" rel="stylesheet/sass">
  .component-map
    width: 100%

    #toggles
      position: absolute
      padding: 2em
      right: 0
      background: white
      width: 300px
</style>



// WEBPACK FOOTER //
// Alarms.vue?42d38a3a